export default __webpack_public_path__ + "static/media/amp.80da8789.png";